/* ================================
   student-mode.js — FINAL (Redirect + Page Protection)

   - Redirects to register after correct code
   - Blocks /pages/students if NOT logged in
   - Allows access ONLY when logged in + student_mode active
   ================================ */

(() => {
  "use strict";

  // ===== CONFIG =====
  const STUDENT_CODE = "Student2026";
  const COOKIE_NAME = "student_mode";
  const COOKIE_VALUE = "1";
  function isRegisterPagestudent() {
    return window.location.pathname.replace(/\/+$/, "") === "/account/register";
  }

  if (isRegisterPagestudent()) {
    const urlParams = new URLSearchParams(window.location.search);
    const hasStudentMode = urlParams.get("student_mode") === "1";

    if (hasStudentMode) {
      setStudentCookie();
      console.log("[MCStudent] student_mode set from register URL");
    }
  }

  function isStudentsPage() {
    return window.location.pathname.replace(/\/+$/, "") === "/pages/students";
  }
  function isRegisterPage() {
    return window.location.pathname.replace(/\/+$/, "") === "/account/register";
  }
  function isLoggedIn() {
    return (
      document.body.classList.contains("customer-logged-in") ||
      document.body.classList.contains("template-customers-account") ||
      !!window.Shopify?.customer
    );
  }

  function isStudentModeActive() {
    return (
      document.cookie.includes("student_mode=1") ||
      localStorage.getItem("student_mode") === "1"
    );
  }

  function setStudentCookie() {
    document.cookie = "student_mode=1; Path=/; Max-Age=604800; SameSite=Lax";
    localStorage.setItem("student_mode", "1");
    console.log("[MCStudent] student_mode enabled");
  }

  function showError(msg) {
    let box = document.querySelector("#student-gate-error");
    if (!box) {
      box = document.createElement("div");
      box.id = "student-gate-error";
      box.style.marginTop = "10px";
      box.style.padding = "10px 12px";
      box.style.borderRadius = "8px";
      box.style.border = "1px solid rgba(0,0,0,0.15)";
      box.style.background = "rgba(255,0,0,0.06)";
      box.style.fontSize = "14px";
      const wrap = document.querySelector("#wlm-wrapper") || document.body;
      wrap.appendChild(box);
    }
    box.textContent = msg;
  }

  function clearError() {
    const box = document.querySelector("#student-gate-error");
    if (box) box.remove();
  }

  function getInput() {
    return document.querySelector("#wlm-pwd") || document.querySelector('input[type="password"]');
  }

  function findEnterButton() {
    const wrap = document.querySelector("#wlm-wrapper") || document;
    const els = wrap.querySelectorAll("button, input[type='submit'], a");
    for (const el of els) {
      const t = (el.textContent || el.value || "").toLowerCase();
      if (t.includes("enter")) return el;
    }
    return null;
  }

  function handleAttempt() {
    const input = getInput();
    if (!input) return;

    const entered = (input.value || "").trim();

    if (!entered) {
      showError("Please enter the student code.");
      return;
    }

    clearError();

    // ✅ SUCCESS → redirect immediately
    if (entered === STUDENT_CODE) {
      setStudentCookie();

      console.log("[MCStudent] Code correct → redirect to register");

      window.location.href = "/account/register?student_mode=1";
      return;
    }

    // ❌ ERROR
    showError("Incorrect code. Please try again.");
  }

  function attach() {
    if (!isStudentsPage()) return;

    const input = getInput();
    const btn = findEnterButton();
    if (!input) return;

    if (!input.__gateAttached) {
      input.__gateAttached = true;
      input.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          handleAttempt();
        }
      });
    }

    if (btn && !btn.__gateAttached) {
      btn.__gateAttached = true;
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        handleAttempt();
      });
    }
  }
  // ================================
  // REGISTER PAGE PROTECTION
  // ================================
  if (isRegisterPage()) {
    const urlParams = new URLSearchParams(window.location.search);
    const hasStudentMode = urlParams.get("student_mode") === "1";

    if (hasStudentMode && isLoggedIn()) {
      console.log("[MCStudent] Already logged in → redirect to students page");
      window.location.replace("/pages/students");
      return;
    }
  }
  // ================================
  // 🔒 PAGE PROTECTION LOGIC
  // ================================
  if (isStudentsPage()) {
    const studentMode = isStudentModeActive();
    const loggedIn = isLoggedIn();

    // ❌ If student mode active but NOT logged in → redirect
    if (studentMode && !loggedIn) {
      console.log("[MCStudent] Block access → redirect to register");
      window.location.href = "/account/register?student_mode=1";
      return;
    }

    // ✅ If logged in → allow access (do nothing)
  }

  // ================================
  // Attach form handlers
  // ================================
  if (isStudentsPage()) {
    window.addEventListener("load", attach);

    new MutationObserver(attach).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

})();